import { render, staticRenderFns } from "./QueueCallList.vue?vue&type=template&id=206c3816&scoped=true"
import script from "./QueueCallList.vue?vue&type=script&lang=js"
export * from "./QueueCallList.vue?vue&type=script&lang=js"
import style0 from "./QueueCallList.vue?vue&type=style&index=0&id=206c3816&prod&lang=css"
import style1 from "./QueueCallList.vue?vue&type=style&index=1&id=206c3816&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c3816",
  null
  
)

export default component.exports